import axios from 'axios';
import Qs from 'qs';

// export const host = 'http://swoole-shop.com'

// 请求拦截器
axios.interceptors.request.use(function (config) {
	let login = localStorage.getItem('login')
	login = JSON.parse(login)
	const token = login ? login.token : null;
    if(token){
        //配置header的token信息
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    // config.url = 'http://xjddi.conjure.net.cn' + config.url;
    // console.log('config', config)
    return config;
}, function (error) {
    return Promise.reject(error);
});
// 响应拦截器
axios.interceptors.response.use(function (response) {
    return response.data;
}, function (error, data) {
	if (error.response) {
		if (error.response.status === 401) {
			// login失效
			location.href = '/login'
			return
		}

    error.response.data.code = error.response.status
    error.response.data.msg = 'Http Code Error!'
		return error.response.data
	} else {
		return Promise.reject(error)
	}
});

// main
export const Main = (data) => {return axios.post('/manage/main', Qs.stringify(data))}

// manage
export const ManageLogin = (data) => {return axios.post('/manage/manage/login', Qs.stringify(data))}
export const ManageReLogin = (data) => {return axios.post('/manage/manage/re-login', Qs.stringify(data))}
export const ManageEditPassword = (data) => {return axios.post('/manage/manage/edit-password', Qs.stringify(data))}
export const ManageIndex = (data) => {return axios.post('/manage/manage/index', Qs.stringify(data))}
export const ManageAdd = (data) => {return axios.post('/manage/manage/add', Qs.stringify(data))}
export const ManageDel = (data) => {return axios.post('/manage/manage/del', Qs.stringify(data))}

// permissions
export const PermissionsIndex = (data) => {return axios.post('/manage/permissions/index', Qs.stringify(data))}
export const PermissionsAdd = (data) => {return axios.post('/manage/permissions/add', Qs.stringify(data))}
export const PermissionsDel = (data) => {return axios.post('/manage/permissions/del', Qs.stringify(data))}

// roles
export const RolesIndex = (data) => {return axios.post('/manage/roles/index', Qs.stringify(data))}
export const RolesAdd = (data) => {return axios.post('/manage/roles/add', Qs.stringify(data))}
export const RolesDel = (data) => {return axios.post('/manage/roles/del', Qs.stringify(data))}

// config
export const ConfigIndex = (data) => {return axios.post('/manage/config/index', Qs.stringify(data))}
export const ConfigUpdate = (data) => {return axios.post('/manage/config/update', Qs.stringify(data))}

// manage login log
export const LoginLogIndex = (data) => {return axios.post('/manage/login-log/index', Qs.stringify(data))}
export const LoginLogClear = (data) => {return axios.post('/manage/login-log/clear', Qs.stringify(data))}

// users
export const UsersIndex = (data) => {return axios.post('/manage/users/index', Qs.stringify(data))}
export const UsersAdd = (data) => {return axios.post('/manage/users/add', Qs.stringify(data))}
export const UsersDel = (data) => {return axios.post('/manage/users/del', Qs.stringify(data))}
export const UsersPrizeNumber = (data) => {return axios.post('/manage/users/prize-number', Qs.stringify(data))}
export const UsersCouponNumber = (data) => {return axios.post('/manage/users/coupon-number', Qs.stringify(data))}
export const UsersSetStatus = (data) => {return axios.post('/manage/users/set-status', Qs.stringify(data))}

/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// user grade
export const UserGradeIndex = (data) => {return axios.post('/manage/user-grade/index', Qs.stringify(data))}
export const UserGradeAdd = (data) => {return axios.post('/manage/user-grade/add', Qs.stringify(data))}
export const UserGradeDel = (data) => {return axios.post('/manage/user-grade/del', Qs.stringify(data))}

// user coupon
export const UserCouponIndex = (data) => {return axios.post('/manage/user-coupon/index', Qs.stringify(data))}
export const UserCouponDel = (data) => {return axios.post('/manage/user-coupon/del', Qs.stringify(data))}

// user commission
export const UserCommissionIndex = (data) => {return axios.post('/manage/user-commission/index', Qs.stringify(data))}

// user cash
export const UserCashIndex = (data) => {return axios.post('/manage/user-cash/index', Qs.stringify(data))}
export const UserCashSetStatus = (data) => {return axios.post('/manage/user-cash/set-status', Qs.stringify(data))}

// staff
export const StaffIndex = (data) => {return axios.post('/manage/staff/index', Qs.stringify(data))}
export const StaffAdd = (data) => {return axios.post('/manage/staff/add', Qs.stringify(data))}
export const StaffDel = (data) => {return axios.post('/manage/staff/del', Qs.stringify(data))}

// staff sts
export const StaffStsIndex = (data) => {return axios.post('/manage/staff-sts/index', Qs.stringify(data))}
// export const StaffStsAdd = (data) => {return axios.post('/manage/staff-sts/add', Qs.stringify(data))}
// export const StaffStsDel = (data) => {return axios.post('/manage/staff-sts/del', Qs.stringify(data))}

// oil gun
export const OilGunIndex = (data) => {return axios.post('/manage/oil-gun/index', Qs.stringify(data))}
export const OilGunAdd = (data) => {return axios.post('/manage/oil-gun/add', Qs.stringify(data))}
export const OilGunDel = (data) => {return axios.post('/manage/oil-gun/del', Qs.stringify(data))}

// goods category
export const GoodsCategoryIndex = (data) => {return axios.post('/manage/goods-category/index', Qs.stringify(data))}
export const GoodsCategoryAdd = (data) => {return axios.post('/manage/goods-category/add', Qs.stringify(data))}
export const GoodsCategoryDel = (data) => {return axios.post('/manage/goods-category/del', Qs.stringify(data))}

// goods
export const GoodsIndex = (data) => {return axios.post('/manage/goods/index', Qs.stringify(data))}
export const GoodsAdd = (data) => {return axios.post('/manage/goods/add', Qs.stringify(data))}
export const GoodsDel = (data) => {return axios.post('/manage/goods/del', Qs.stringify(data))}
export const GoodsFormInit = (data) => {return axios.post('/manage/goods/form-init', Qs.stringify(data))}

// goods order verify
export const GoodsOrderVerifyIndex = (data) => {return axios.post('/manage/goods-order-verify/index', Qs.stringify(data))}

// oil order
export const OilOrderIndex = (data) => {return axios.post('/manage/oil-order/index', Qs.stringify(data))}

// goods order
export const GoodsOrderIndex = (data) => {return axios.post('/manage/goods-order/index', Qs.stringify(data))}
export const GoodsOrderSetStatus = (data) => {return axios.post('/manage/goods-order/set-status', Qs.stringify(data))}
export const GoodsOrderSetStatusCode = (data) => {return axios.post('/manage/goods-order/set-status-code', Qs.stringify(data))}

// recharge order
export const RechargeIndex = (data) => {return axios.post('/manage/recharge/index', Qs.stringify(data))}

// coupon
export const CouponIndex = (data) => {return axios.post('/manage/coupon/index', Qs.stringify(data))}
export const CouponAdd = (data) => {return axios.post('/manage/coupon/add', Qs.stringify(data))}
export const CouponDel = (data) => {return axios.post('/manage/coupon/del', Qs.stringify(data))}
export const CouponAddCarWash = (data) => {return axios.post('/manage/coupon/add_car_wash', Qs.stringify(data))}

// banner
export const BannerIndex = (data) => {return axios.post('/manage/banner/index', Qs.stringify(data))}
export const BannerAdd = (data) => {return axios.post('/manage/banner/add', Qs.stringify(data))}
export const BannerDel = (data) => {return axios.post('/manage/banner/del', Qs.stringify(data))}

// user prize
export const UserPrizeIndex = (data) => {return axios.post('/manage/user-prize/index', Qs.stringify(data))}
export const UserPrizeSetStatus = (data) => {return axios.post('/manage/user-prize/set-status', Qs.stringify(data))}

// prize
export const PrizeIndex = (data) => {return axios.post('/manage/prize/index', Qs.stringify(data))}
export const PrizeAdd = (data) => {return axios.post('/manage/prize/add', Qs.stringify(data))}
export const PrizeDel = (data) => {return axios.post('/manage/prize/del', Qs.stringify(data))}
export const PrizeConfirm = (data) => {return axios.post('/manage/prize/confirm', Qs.stringify(data))}

// recharge card
export const RechargeCardIndex = (data) => {return axios.post('/manage/recharge-card/index', Qs.stringify(data))}
export const RechargeCardAdd = (data) => {return axios.post('/manage/recharge-card/add', Qs.stringify(data))}
export const RechargeCardSetStatus = (data) => {return axios.post('/manage/recharge-card/set-status', Qs.stringify(data))}
